// Shared helper: upload a generated document (Blob) to the client's Google Drive
// folder AND link it on the client's Documents page (the `documents` table), so
// nurse assessments, supervisor visits, etc. all surface in one place.

import { supabase, addDocument, updateClient } from './supabase';
import { CLIENT_DRIVE_ROOT } from './driveRoots';

function blobToBase64(blob) {
  return blob.arrayBuffer().then((buf) => {
    const bytes = new Uint8Array(buf);
    let binary = '';
    for (let i = 0; i < bytes.length; i += 8192) binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
    return btoa(binary);
  });
}

// clientCode = the "G###" code (Drive folder name); clientUuid = clients.id (FK).
export async function uploadAndLinkDoc({ blob, filename, clientCode, clientUuid, documentType, subfolder, notes, profile, contentType, existingFolderId }) {
  const rootFolderId = CLIENT_DRIVE_ROOT;

  const fileBase64 = await blobToBase64(blob);
  const { data: { session } } = await supabase.auth.getSession();
  const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/upload-to-drive`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
    body: JSON.stringify({ fileBase64, filename, clientId: clientCode, rootFolderId, subfolder, contentType }),
  });
  const r = await res.json();
  if (!r.success || !r.webViewLink) throw new Error(r.error || 'Drive upload failed');

  // First document for this client: remember the folder Drive just created.
  // The query builder is thenable but has no .catch, so resolve it first.
  if (!existingFolderId && r.clientFolderId && clientUuid) {
    Promise.resolve(updateClient(clientUuid, { drive_folder_id: r.clientFolderId })).catch(() => {});
  }

  await addDocument({
    client_id: clientUuid,
    document_name: filename,
    document_type: documentType,
    drive_url: r.webViewLink,
    notes: notes || null,
    uploaded_by_id: profile?.id || null,
    uploaded_by_name: profile?.full_name || null,
  });
  return r.webViewLink;
}
